var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCoins = function SvgCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4606 12.6199C17.5195 12.6199 19.9993 11.5186 19.9993 10.1599C19.9993 8.80133 17.5195 7.69995 14.4606 7.69995C11.4016 7.69995 8.92188 8.80133 8.92188 10.1599C8.92188 11.5186 11.4016 12.6199 14.4606 12.6199Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 10.1599V17.5399C8.92188 18.8929 11.3835 19.9999 14.4606 19.9999C17.5377 19.9999 19.9993 18.8929 19.9993 17.5399V10.1599",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 13.8496C19.9993 15.2026 17.5377 16.3096 14.4606 16.3096C11.3835 16.3096 8.92188 15.2026 8.92188 13.8496",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3389 5.24079C12.9007 4.35381 11.2266 3.92484 9.53872 4.01079C6.47396 4.01079 4 5.11779 4 6.47079C4 7.19648 4.71388 7.84838 5.84624 8.31578",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84624 15.6957C4.71388 15.2283 4 14.5764 4 13.8507V6.4707",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84624 12.0054C4.71388 11.538 4 10.8861 4 10.1604",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCoins;